"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

const List = dynamic(async () => (await import("./List")).List);

export const listInputs = [
  {
    name: "items",
    type: "list",
    required: true,
    copyOnAdd: false,
    subFields: [
      {
        name: "title",
        type: "string",
        required: true,
      },
      {
        name: "link",
        type: "url",
        required: true,
      },
      {
        name: "isArrowHidden",
        type: "boolean",
        defaultValue: false,
        helperText: "Hide arrow",
      },
    ],
    defaultValue: [
      {
        title: "Special Deals",
        link: "/",
      },
      {
        title: "Special Offers",
        link: "/",
      },
      {
        title: "Special Discounts",
        link: "/",
      },
    ],
  },
] as const satisfies Inputs;

export const ListComponent: RegisteredComponent = {
  name: "List",
  component: List,
  defaultStyles: {
    marginTop: "0px",
  },
  inputs: listInputs,
};
